if (!Symbol.species) {
    Symbol.species = Symbol.for('@@species');
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/ml-regression-polynomial/node_modules/ml-matrix/src/symbol-species.js
// module id = 63
// module chunks = 0